export default __webpack_public_path__ + "static/media/honda-large-logo.7a32d791.svg";